import userAgentMixin from '@/mixins/userAgent';

export default {
  mixins: [userAgentMixin],
};



// WEBPACK FOOTER //
// ./src/components/pages/page-user-status/page-user-status.js